/**
 * i18next Configuration
 * Multi-language support for checkout platform
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from '../locales/es.json';
import en from '../locales/en.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
};

// Detect language from URL query param, localStorage, or browser
const getInitialLanguage = (): string => {
  // Check URL query param
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('lang');
  if (langParam && ['es', 'en'].includes(langParam)) {
    return langParam;
  }

  // Check localStorage
  const savedLang = localStorage.getItem('i18nextLng');
  if (savedLang && ['es', 'en'].includes(savedLang)) {
    return savedLang;
  }

  // Check browser language
  const browserLang = navigator.language?.split('-')[0];
  if (browserLang && ['es', 'en'].includes(browserLang)) {
    return browserLang;
  }

  // Default to Spanish
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
